export const parseBooleanString = (str: unknown) => /true/i.test(str as string)
